import { ArrowDownIcon } from "@kursk/components/ui/icons";
import classNames from "classnames";
import styles from './CustomArrow.module.scss';

interface IProps {
  direction: 'left' | 'right';
  onClick?: () => void;
}

export function CustomArrow({ direction, onClick }: IProps) {
  return (
    <button
      className={classNames(styles.wrapper, direction == 'left' ? styles.left : styles.right)}
      onClick={onClick}
    >
      <ArrowDownIcon width={12} height={5} />
    </button>
  )
}